module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [(_vm.hasResults) ? _c('div', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('div', {
    staticClass: "bar-chart"
  }, [_c('canvas', {
    attrs: {
      "id": _vm.chartid,
      "height": _vm.chartHeight
    }
  })]), _vm._v(" "), (_vm.showLegend) ? _c('div', [(_vm.hasResults) ? _c('ol', {
    staticClass: "l-clearfix bar-legend",
    class: [_vm.legendColor]
  }, [_vm._l((_vm.barChartAmounts), function(amount, index) {
    return _c('li', {
      staticClass: "l-clearfix bar-legend-series"
    }, [(_vm.chartLegendLink) ? _c('router-link', {
      class: 'bar-legend-series-item bar-legend-series-link',
      attrs: {
        "to": {
          name: _vm.chartLegendLink,
          params: {
            id: _vm.barChartIds[index]
          }
        }
      }
    }, [_c('span', {
      staticClass: "bar-legend-title s-icon"
    }, [_c('i', [_vm._v("\n                        " + _vm._s(index + 1) + _vm._s(index === 0 ? 'st' : '') + _vm._s(index === 1 ? 'nd' : '') + _vm._s(index === 2 ? 'rd' : '') + _vm._s(index > 2 ? 'th' : '') + "\n                      ")]), _vm._v("\n                      " + _vm._s(_vm.barChartLabels[index]) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "bar-legend-amount"
    }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(amount).toLocaleString('en-US')))])]) : _c('div', [_c('span', {
      staticClass: "bar-legend-series-item"
    }, [_c('span', {
      staticClass: "bar-legend-title"
    }, [_vm._v(_vm._s(_vm.barChartLabels[index]))]), _vm._v(" "), _c('span', {
      staticClass: "bar-legend-amount"
    }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(amount).toLocaleString('en-US')))])])])], 1)
  }), _vm._v(" "), (_vm.noDataAvailable) ? _c('li', [_c('span', {
    staticClass: "bar-legend-title"
  }, [_vm._v(_vm._s(_vm.noDataAvailable.title))]), _vm._v(" "), _c('span', {
    staticClass: "bar-legend-amount"
  }, [_vm._v(_vm._s(_vm.prefix) + _vm._s(Number(_vm.noDataAvailable.amount).toLocaleString('en-US')))])]) : _vm._e()], 2) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "bar-message",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('p', [_vm._v("No results that match those filters.")])]), _vm._v(" "), _c('div', {
    staticClass: "bar-loader",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderBars')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-403182dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barCharts/BarChart.vue
// module id = 461
// module chunks = 1